import { useQuery } from '@tanstack/react-query';

import getV1StockOdtOrderOrderlistfilterById from '@services/api/stock/order/dtDetail';

/**
 * @param {string}  orderNo
 */
function useOrderDtDetail(orderNo) {
  const { cb, key } = getV1StockOdtOrderOrderlistfilterById(orderNo);

  const { data, isSuccess, isLoading } = useQuery(key, cb, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, isLoading };
}

export default useOrderDtDetail;
